/**
 * Links used by the navigation bar and menu.
 *
 * "More games" points at our own page rather than an outside list, the way the
 * other Teuteuf games do it. The list of games on that page comes from the
 * official `@teuteuf-games/teuteuf-games` component — see TeuteufGamesPage.js.
 */
export const MORE_GAMES_URL = '/teuteuf-games';
export const STATS_URL = '/stats';
export const CONSTRUCT_URL = '/construct';
export const FEEDBACK_URL =
  'https://teuteuf.notion.site/17eeff4e9f3880e2a6aeef075e74939b?pvs=105';
export const PRIVACY_URL = '/privacy-policy/';
export const SETTINGS_URL = '/settings';
export const ACCOUNT_URL = '/account';
